import gql from "graphql-tag";

export const CompanyFragments = {
    adminEditableFields: gql`
        fragment adminEditableFields on Company {
            name
            analyzeServerAddress
            analyzeDeploymentType
            admins {
                id
                email
            }
            settings {
                timezone
                locale
            }
        }
    `,
    operatingSchedule: gql`
        fragment operatingSchedule on Company {
            operatingSchedule {
                enabled
                days {
                    monday {
                        enabled
                        periods {
                            start
                            end
                        }
                    }
                    tuesday {
                        enabled
                        periods {
                            start
                            end
                        }
                    }
                    wednesday {
                        enabled
                        periods {
                            start
                            end
                        }
                    }
                    thursday {
                        enabled
                        periods {
                            start
                            end
                        }
                    }
                    friday {
                        enabled
                        periods {
                            start
                            end
                        }
                    }
                    saturday {
                        enabled
                        periods {
                            start
                            end
                        }
                    }
                    sunday {
                        enabled
                        periods {
                            start
                            end
                        }
                    }
                }
            }
        }
    `,
    authSettings: gql`
        fragment authSettings on Company {
            authSettings {
                sso {
                    enabled
                    federatedIDPs {
                        providerType
                        providerDetails
                        attributeMappings
                    }
                }
                grabcadDetails {
                    userPoolId
                    authDomainUrl
                }
            }
        }
    `,
    // Company users only get read-only Control access, so omit providerDetails/attributeMappings,
    // which GraphQL Shield denies to Role.User and would otherwise fail the whole query.
    authSettingsReadOnly: gql`
        fragment authSettingsReadOnly on Company {
            authSettings {
                sso {
                    enabled
                    federatedIDPs {
                        providerType
                    }
                }
                grabcadDetails {
                    userPoolId
                    authDomainUrl
                }
            }
        }
    `,
};
